import { ref, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { defineStore } from 'pinia';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';

export const useProjectsDatasetsStore = defineStore('projectsDatasets', () => {
  const store = useStore();
  const route = useRoute();
  const dataConnect = new DatastoreConnect();
  const isLoadingInitialData = ref(false);

  const projectList = computed(() => store.state.projects.projectList);
  const datasets = computed(() => store.state.datasets.datasetList);

  const currentProject = computed({
    get: () => store.state.projects.currentProject,
    set: (value) => store.commit('projects/setCurrentProject', value),
  });
  const currentDataset = computed({
    get: () => store.state.datasets.currentDataset,
    set: (value) => store.commit('datasets/setCurrentDataset', value),
  });

  const user = computed(() => store.state.user.user);

  const showParked = computed(() => store.state.datasets.showParked);

  async function loadInitialData() {
    if (!user.value) return;

    try {
      if (!projectList.value?.length) {
        await getProjectList();
      }

      if (route.params.projectId) {
        const project = projectList.value.find(
          (e) => e.id === parseInt(route.params.projectId),
        );
        if (project) {
          currentProject.value = project;
          await refreshDatasetList(project.id);
        }
      }

      if (route.query.dataset) {
        const dataset = datasets.value.find((e) => e.id === parseInt(route.query.dataset));
        if (dataset) currentDataset.value = dataset;
      } else {
        store.commit('datasets/setCurrentDataset', null);
      }
    } finally {
      isLoadingInitialData.value = false;
    }
  }

  async function refreshDatasetList(project_id) {
    const datasetList = await getDatasets(project_id);
    store.commit('datasets/setDatasetList', datasetList);
    //   if (props.hasDatasetNavigation && !currentDataset.value && datasetList.length) {
    //     currentDataset.value = datasetList[0];
    //   }
  }

  async function getDatasets(project_id) {
    if (!project_id) return [];
    try {
      const resp = await dataConnect.getDatasetList({
        project_id,
        get_parked: showParked.value,
        get_annotation_sets: true,
        get_labels: true,
        get_groups: true,
      });
      return resp.error ? [] : resp.result;
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  async function getProjectList() {
    try {
      const data = await dataConnect.getProjectList();
      store.commit('projects/setProjectList', data.result);
    } catch (e) {
      console.error(e);
    }
  }

  async function refreshUserList(context, organization_id) {
    await dataConnect.getUserListByOrganization({ organization_id })
      .then((data) => {
        if (data.result) {
          context.commit('user/setUserList', data.result, { root: true });
        }
      })
      .catch((error) => {
        // TODO: handle error
        console.log(error);
      });
  }

  return {
    projectList,
    datasets,
    currentProject,
    currentDataset,
    isLoadingInitialData,
    loadInitialData,
    getProjectList,
    getDatasets,
    refreshDatasetList,
    refreshUserList,
  };
});
